"use client";

import { Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";

import { Button } from "@/components/ui/button";
import { useToast } from "@/components/ui/use-toast";
import Link from "@/i18n/i18n-link";
// import { ModeToggle } from "../ui/theme-toggle";

export function ModeToggle() {
  const { toast } = useToast();
  const { theme, setTheme } = useTheme();
  const environment = process.env.NEXT_PUBLIC_ENVIRONMENT;

  if (environment === "dev" && theme === "dark") {
    return (
      <Button
        onClick={() => {
          setTheme("light");
          toast({
            title: "Fear of The Dark?",
            description:
              "Por que vc tem medo do escuro? Veja esse vídeo para te acalmar",
            action: (
              <Button asChild variant="outline" size="sm">
                <Link
                  className="text-primary underline"
                  href={`https://www.youtube.com/watch?v=gLsi4hDEDVE`}
                  target="_blank"
                >
                  Ver vídeo
                </Link>
              </Button>
            ),
          });
        }}
        variant="ghost"
        size="icon"
      >
        <Sun className="h-[1.1rem] w-[1.1rem] rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0" />
        <Moon className="absolute h-[1.1rem] w-[1.1rem] rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" />
        <span className="sr-only">Toggle theme</span>
      </Button>
    );
  }

  return (
    <Button
      onClick={() => {
        theme === "light" ? setTheme("dark") : setTheme("light");
      }}
      variant="ghost"
      size="icon"
      suppressHydrationWarning
    >
      <Sun className="h-[1.1rem] w-[1.1rem] rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0" />
      <Moon className="absolute h-[1.1rem] w-[1.1rem] rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" />
      <span className="sr-only">Toggle theme</span>
    </Button>
  );
}
